import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Layout from "../Layout";

const tabs = [
  { to: "/statistics/equipment", label: "Подстанциялар", icon: "equipment", subtitle: "Ускуналар мавжудлиги" },
  { to: "/statistics/networks", label: "Тармоқлар", icon: "networks", subtitle: "Таянчлар сони ва ҳолати" },
  { to: "/statistics/activity", label: "Фаоллик", icon: "activity", subtitle: "Киритилган ўзгаришлар" },
  { to: "/statistics/employees", label: "Ходимлар", icon: "employees", subtitle: "Амаллар ва кўриклар" },
  { to: "/statistics/accidents", label: "Ўчишлар", icon: "accidents", subtitle: "Ҳодисалар ва филиаллар" },
];

export function StatisticsIcon({ type, ...props }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
    {type === "equipment" ? <><path d="M4 21V8l8-5 8 5v13M3 21h18M8 11h2m4 0h2M8 15h2m4 0h2M10 21v-3h4v3" /></> : type === "networks" ? <><path d="M9 3h6l4 18M9 3 5 21M7 10h10M6 15h12M4 21h16M3 6h18M5 6v3m14-3v3M8 15l8 6m0-6-8 6" /></> : type === "activity" ? <><path d="M3 13h4l3-8 4 14 3-6h4" /><path d="M3 4v16" opacity=".35" /></> : type === "employees" ? <><circle cx="9" cy="7" r="3" /><path d="M3 21v-3a6 6 0 0 1 12 0v3M16 4a3 3 0 0 1 0 6m3 11v-3a6 6 0 0 0-3-5" /></> : type === "accidents" ? <><path d="m13 2-8 12h6l-1 8 9-13h-6l1-7Z" /></> : <><path d="M4 19h16M7 15v-4m5 4V5m5 10V8" /></>}
  </svg>;
}

export default function StatisticsLayout({ title, description, children }) {
  const location = useLocation();
  const navigate = useNavigate();
  return <Layout>
    <div className="st-page">
      <div className="st-shell">
        <header className="st-hero">
          <div>
            <span className="st-eyebrow"><StatisticsIcon /> БОШҚАРУВ СТАТИСТИКАСИ</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          <span className="st-scope"><span /> Барча филиаллар</span>
        </header>
        <label className="st-mobile-nav"><span>Статистика бўлими</span><select value={location.pathname} onChange={(event) => navigate(event.target.value)}>{tabs.map((tab) => <option key={tab.to} value={tab.to}>{tab.label} — {tab.subtitle}</option>)}</select></label>
        <div className="st-workspace">
          <aside className="st-sidebar">
            <div className="st-sidebar__heading">БЎЛИМЛАР</div>
            <nav className="st-tabs" aria-label="Статистика бўлимлари">
              {tabs.map((tab) => <NavLink key={tab.to} to={tab.to} className={({ isActive }) => `st-tab${isActive ? " is-active" : ""}`}>
                <StatisticsIcon type={tab.icon} />
                <span><strong>{tab.label}</strong><small>{tab.subtitle}</small></span>
              </NavLink>)}
            </nav>
          </aside>
          <div className="st-content">{children}</div>
        </div>
      </div>
    </div>
  </Layout>;
}
